import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ReceiptPostOfficeState} from "@/interfaces/state";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {DebtPostOffice} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {ReceiptPostOfficeParams} from "@/modules/receiptsexpenses/receiptpostoffice/params";
import { union, difference } from 'lodash';
import {listDebtPostOffice, receiptPostOffice} from "@/modules/receiptsexpenses/receiptpostoffice/services";

@Module({ dynamic: true, name: "receiptPostOfficeStore", store })
class ReceiptPostOfficeModule extends VuexModule implements ReceiptPostOfficeState {
    data: IdMapper<DebtPostOffice> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ReceiptPostOfficeParams = new ReceiptPostOfficeParams();

    @Mutation
    private MAP_DEBT_POST_OFFICE(payload: any) {
        const idMapper: IdMapper<DebtPostOffice> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((debt: DebtPostOffice, index: number) => {
            idMapper[debt.id] = {...debt, stt: index + 1};
            return debt.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_DEBT_POST_OFFICE(payload: any) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private UPDATE_PARAMS_DEBT_POST_OFFICE(payload: any) {
        this.params = payload;
    }

    @Mutation
    private REMOVE_DEBT_POST_OFFICE_BY_IDS(payload: number[]) {
        this.ids = this.ids.filter((id: number) => !payload.includes(id));
        payload.forEach((id: number) => delete this.data[id]);
    }

    @Mutation
    private CLEAR_DEBT_POST_OFFICE_STORE() {
        this.ids = [];
        this.data = {};
    }

    @Action({ rawError: true })
    public async listDebtPostOffice(params: any) {
        const { data } = await listDebtPostOffice(params);
        this.MAP_DEBT_POST_OFFICE(data);
        return data.datas;
    }

    @Action({ rawError: true })
    public updateParamsDebtPostOffice(payload: any) {
        this.UPDATE_PARAMS_DEBT_POST_OFFICE(payload);
    }

    @Action({ rawError: true })
    public async receiptPostOffice(data: any) {
        await receiptPostOffice(data);
        // this.REMOVE_DEBT_POST_OFFICE_BY_IDS(data.debtIds);
    }

    @Action({ rawError: true })
    public clearDebtPostOfficeStore() {
        this.CLEAR_DEBT_POST_OFFICE_STORE();
    }
}

export const ReceiptPostOfficeStore = getModule(ReceiptPostOfficeModule);